import { JUSTIFICATIVA_MAX_LENGTH } from "../inativar-papel-obra-dialog/inativar-papel-obra-dialog.constants";
import type {
  ConflitoJustificativaProps,
  ConflitoJustificativaViewModel,
} from "./types-conflito-justificativa";

export function useConflitoJustificativa({
  id,
  value,
  onChange,
  error,
  disabled,
  divided,
  testId,
  maxLength = JUSTIFICATIVA_MAX_LENGTH,
  hideRequiredHint = false,
  placeholder,
}: ConflitoJustificativaProps): ConflitoJustificativaViewModel {
  return {
    id,
    value,
    error,
    disabled,
    divided,
    testId,
    errorTestId: `${testId}-error`,
    maxLength,
    hideRequiredHint,
    placeholder,
    digitar: (texto) => onChange(texto.slice(0, maxLength)),
  };
}
